import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _account = {
    dateCreated: 'google.protobuf.Timestamp',
    dateUpdated: 'google.protobuf.Timestamp',
};
var _accountResponse = { account: '_account' };
var _accountsResponse = { accounts: '_account' };
var _assignUserToTeamRequest = {};
var _createAccountAndAssignUserRequest = {};
var _createAccountForMyUserRequest = {};
var _createAccountRequest = {};
var _createAccountResponse = {};
var _createAccountTenantRequest = {};
var _createAccountTenantResponse = {};
var _deleteAccountRequest = {};
var _emptyResponse = {};
var _getAccountRequest = {};
var _getAccountsRequest = {};
var _getMyAccountRequest = {};
var _getMyUserAccountsRequest = {};
var _getParentAccountInfoRequest = {};
var _getParentAccountInfoResponse = {};
var _getSubAccountsRequest = {};
var _getSubAccountsResponse = {};
var _getTeamMemberRequest = {};
var _getTeamMemberResponse = { user: '_user' };
var _getUserAccountRequest = {};
var _getUserAccountsRequest = {};
var _isTeamRequest = {};
var _isTeamResponse = {};
var _listTeamMembersIdsRequest = {};
var _listTeamMembersIdsResponse = {};
var _listTeamMembersRequest = {};
var _listTeamMembersResponse = { users: '_user' };
var _markAccountFlagRequest = {};
var _removeTeamMemberRequest = {};
var _setIsReadOnlyAccountRequest = {};
var _updateAccountRequest = {};
var _updateParentAccountRequest = {};
var _updateParentAccountResponse = {};
var _updateSlugRequest = {};
var _user = { joinedAt: 'google.protobuf.Timestamp' };
function resolveComWixpressAccountApiAccountServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/account-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
            {
                srcPath: '/account-server',
                destPath: '',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/account-server',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/account-server',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/accounts',
                destPath: '',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressAccountApiTeamServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/account-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
            {
                srcPath: '/account-server',
                destPath: '',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/account-server',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/account-server',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/accounts',
                destPath: '',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/account-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function listTeamMembers(payload) {
    var _a = serializer(_listTeamMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listTeamMembersResponse, { _user: _user }).fromJSON;
    function __listTeamMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'GET',
            methodFqn: 'com.wixpress.account.api.TeamService.listTeamMembers',
            url: resolveComWixpressAccountApiTeamServiceUrl({
                protoPath: '/v1/team',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listTeamMembers.fromReq = fromReq;
    __listTeamMembers.__isAmbassador = true;
    return __listTeamMembers;
}
export function listTeamMembersIds(payload) {
    var _a = serializer(_listTeamMembersIdsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listTeamMembersIdsResponse, {}).fromJSON;
    function __listTeamMembersIds(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'GET',
            methodFqn: 'com.wixpress.account.api.TeamService.listTeamMembersIds',
            url: resolveComWixpressAccountApiTeamServiceUrl({
                protoPath: '/v1/accounts/{accountId}/ids',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listTeamMembersIds.fromReq = fromReq;
    __listTeamMembersIds.__isAmbassador = true;
    return __listTeamMembersIds;
}
export function removeTeamMember(payload) {
    var _a = serializer(_removeTeamMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_emptyResponse, {}).fromJSON;
    function __removeTeamMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'DELETE',
            methodFqn: 'com.wixpress.account.api.TeamService.removeTeamMember',
            url: resolveComWixpressAccountApiTeamServiceUrl({
                protoPath: '/v1/team/{userId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeTeamMember.fromReq = fromReq;
    __removeTeamMember.__isAmbassador = true;
    return __removeTeamMember;
}
export function assignUserToTeam(payload) {
    var _a = serializer(_assignUserToTeamRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_emptyResponse, {}).fromJSON;
    function __assignUserToTeam(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'POST',
            methodFqn: 'com.wixpress.account.api.TeamService.assignUserToTeam',
            url: resolveComWixpressAccountApiTeamServiceUrl({
                protoPath: '/v1/team',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignUserToTeam.fromReq = fromReq;
    __assignUserToTeam.__isAmbassador = true;
    return __assignUserToTeam;
}
export function getTeamMember(payload) {
    var _a = serializer(_getTeamMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTeamMemberResponse, { _user: _user }).fromJSON;
    function __getTeamMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'GET',
            methodFqn: 'com.wixpress.account.api.TeamService.getTeamMember',
            url: resolveComWixpressAccountApiTeamServiceUrl({
                protoPath: '/v1/team/members',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTeamMember.fromReq = fromReq;
    __getTeamMember.__isAmbassador = true;
    return __getTeamMember;
}
/** Get account data by user id */
export function getUserAccount(payload) {
    var _a = serializer(_getUserAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_account, {}).fromJSON;
    function __getUserAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'GET',
            methodFqn: 'com.wixpress.account.api.AccountService.getUserAccount',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/users/{userId}/account',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getUserAccount.fromReq = fromReq;
    __getUserAccount.__isAmbassador = true;
    return __getUserAccount;
}
/** Get accounts data by user id */
export function getUserAccounts(payload) {
    var _a = serializer(_getUserAccountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_accountsResponse, { _account: _account }).fromJSON;
    function __getUserAccounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'GET',
            methodFqn: 'com.wixpress.account.api.AccountService.getUserAccounts',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/users/{userId}/accounts',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getUserAccounts.fromReq = fromReq;
    __getUserAccounts.__isAmbassador = true;
    return __getUserAccounts;
}
/** Get accounts data by current user */
export function getMyUserAccounts(payload) {
    var _a = serializer(_getMyUserAccountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_accountsResponse, { _account: _account }).fromJSON;
    function __getMyUserAccounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'GET',
            methodFqn: 'com.wixpress.account.api.AccountService.getMyUserAccounts',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/users/my_accounts',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMyUserAccounts.fromReq = fromReq;
    __getMyUserAccounts.__isAmbassador = true;
    return __getMyUserAccounts;
}
export function getAccount(payload) {
    var _a = serializer(_getAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_accountResponse, { _account: _account }).fromJSON;
    function __getAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'GET',
            methodFqn: 'com.wixpress.account.api.AccountService.getAccount',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts/{accountId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAccount.fromReq = fromReq;
    __getAccount.__isAmbassador = true;
    return __getAccount;
}
/** Get logged-in user account */
export function getMyAccount(payload) {
    var _a = serializer(_getMyAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_accountResponse, { _account: _account }).fromJSON;
    function __getMyAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'GET',
            methodFqn: 'com.wixpress.account.api.AccountService.getMyAccount',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts/my_account',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMyAccount.fromReq = fromReq;
    __getMyAccount.__isAmbassador = true;
    return __getMyAccount;
}
export function getAccounts(payload) {
    var _a = serializer(_getAccountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_accountsResponse, { _account: _account }).fromJSON;
    function __getAccounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'GET',
            methodFqn: 'com.wixpress.account.api.AccountService.getAccounts',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAccounts.fromReq = fromReq;
    __getAccounts.__isAmbassador = true;
    return __getAccounts;
}
/**
 * Creates a new Wix account, and a new Wix user under this account, as the account owner.
 * If the context contains a targetAccountId, the account will be created as a sub account of the target account (which will be its parent).
 * Otherwise, the account will be created without a parent account.
 */
export function createAccount(payload) {
    var _a = serializer(_createAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createAccountResponse, {}).fromJSON;
    function __createAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'POST',
            methodFqn: 'com.wixpress.account.api.AccountService.createAccount',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createAccount.fromReq = fromReq;
    __createAccount.__isAmbassador = true;
    return __createAccount;
}
/** creates account for the logged in user */
export function createAccountForMyUser(payload) {
    var _a = serializer(_createAccountForMyUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_accountResponse, { _account: _account }).fromJSON;
    function __createAccountForMyUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'POST',
            methodFqn: 'com.wixpress.account.api.AccountService.createAccountForMyUser',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createAccountForMyUser.fromReq = fromReq;
    __createAccountForMyUser.__isAmbassador = true;
    return __createAccountForMyUser;
}
export function createAccountTenant(payload) {
    var _a = serializer(_createAccountTenantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createAccountTenantResponse, {}).fromJSON;
    function __createAccountTenant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'POST',
            methodFqn: 'com.wixpress.account.api.AccountService.createAccountTenant',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts/create_tenant',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createAccountTenant.fromReq = fromReq;
    __createAccountTenant.__isAmbassador = true;
    return __createAccountTenant;
}
/**
 * Creates a new Wix account and assign Wix user under this account, as the account owner.
 * If parentAccountId exists, the account will be created as a sub account of the parent account.
 * Otherwise, the account will be created without a parent account.
 */
export function createAccountAndAssignUser(payload) {
    var _a = serializer(_createAccountAndAssignUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_accountResponse, { _account: _account }).fromJSON;
    function __createAccountAndAssignUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'POST',
            methodFqn: 'com.wixpress.account.api.AccountService.createAccountAndAssignUser',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts/{userId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createAccountAndAssignUser.fromReq = fromReq;
    __createAccountAndAssignUser.__isAmbassador = true;
    return __createAccountAndAssignUser;
}
export function updateAccount(payload) {
    var _a = serializer(_updateAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_accountResponse, { _account: _account }).fromJSON;
    function __updateAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'PATCH',
            methodFqn: 'com.wixpress.account.api.AccountService.updateAccount',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts/{accountId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateAccount.fromReq = fromReq;
    __updateAccount.__isAmbassador = true;
    return __updateAccount;
}
/**
 * Updates the parent account of the account that is passed in the target account header.
 * The permission required for removing a parent account: "ACCOUNT.REMOVE_PARENT_ACCOUNT"
 */
export function updateParentAccount(payload) {
    var _a = serializer(_updateParentAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateParentAccountResponse, {}).fromJSON;
    function __updateParentAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'PATCH',
            methodFqn: 'com.wixpress.account.api.AccountService.updateParentAccount',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts/parent',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateParentAccount.fromReq = fromReq;
    __updateParentAccount.__isAmbassador = true;
    return __updateParentAccount;
}
export function deleteAccount(payload) {
    var _a = serializer(_deleteAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_emptyResponse, {}).fromJSON;
    function __deleteAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'DELETE',
            methodFqn: 'com.wixpress.account.api.AccountService.deleteAccount',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts/{accountId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteAccount.fromReq = fromReq;
    __deleteAccount.__isAmbassador = true;
    return __deleteAccount;
}
export function updateSlugName(payload) {
    var _a = serializer(_updateSlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_emptyResponse, {}).fromJSON;
    function __updateSlugName(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'PATCH',
            methodFqn: 'com.wixpress.account.api.AccountService.updateSlugName',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts/{accountId}/slug',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSlugName.fromReq = fromReq;
    __updateSlugName.__isAmbassador = true;
    return __updateSlugName;
}
/** Returns whether the account is a team account. */
export function isTeam(payload) {
    var _a = serializer(_isTeamRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_isTeamResponse, {}).fromJSON;
    function __isTeam(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'GET',
            methodFqn: 'com.wixpress.account.api.AccountService.isTeam',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts/{accountId}/team',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __isTeam.fromReq = fromReq;
    __isTeam.__isAmbassador = true;
    return __isTeam;
}
/** Marking an account flag explicitly. Returns the new account data */
export function markAccountFlag(payload) {
    var _a = serializer(_markAccountFlagRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_accountResponse, { _account: _account }).fromJSON;
    function __markAccountFlag(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'PATCH',
            methodFqn: 'com.wixpress.account.api.AccountService.markAccountFlag',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts/{accountId}/flags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAccountFlag.fromReq = fromReq;
    __markAccountFlag.__isAmbassador = true;
    return __markAccountFlag;
}
/**
 * Gets information about the parent account of the target account (taken from the context targetAccountId field).
 * If the target account has no parent, no information will be returned.
 */
export function getParentAccountInfo(payload) {
    var _a = serializer(_getParentAccountInfoRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getParentAccountInfoResponse, {}).fromJSON;
    function __getParentAccountInfo(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'GET',
            methodFqn: 'com.wixpress.account.api.AccountService.getParentAccountInfo',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts/parent/info',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getParentAccountInfo.fromReq = fromReq;
    __getParentAccountInfo.__isAmbassador = true;
    return __getParentAccountInfo;
}
/**
 * Gets the sub accounts of the target account (taken from the context targetAccountId field).
 * If the target account has no sub accounts, an empty list will be returned.
 */
export function getSubAccounts(payload) {
    var _a = serializer(_getSubAccountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSubAccountsResponse, {}).fromJSON;
    function __getSubAccounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'GET',
            methodFqn: 'com.wixpress.account.api.AccountService.getSubAccounts',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts/sub_accounts',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSubAccounts.fromReq = fromReq;
    __getSubAccounts.__isAmbassador = true;
    return __getSubAccounts;
}
/** set the account's is_read_only flag */
export function setIsReadOnlyAccount(payload) {
    var _a = serializer(_setIsReadOnlyAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_emptyResponse, {}).fromJSON;
    function __setIsReadOnlyAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.account.v2.account',
            method: 'PATCH',
            methodFqn: 'com.wixpress.account.api.AccountService.setIsReadOnlyAccount',
            url: resolveComWixpressAccountApiAccountServiceUrl({
                protoPath: '/v1/accounts/{accountId}/is_read_only',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setIsReadOnlyAccount.fromReq = fromReq;
    __setIsReadOnlyAccount.__isAmbassador = true;
    return __setIsReadOnlyAccount;
}
//# sourceMappingURL=http.impl.js.map